import React from "react";
import { Card, Badge } from "react-bootstrap";
import { FaUser, FaEnvelope, FaPhone } from "react-icons/fa";
import "./UserCard.css";

const UserCard = ({ user }) => {
  const getRoleBadgeVariant = (role) => {
    switch (role) {
      case "admin":
        return "danger";
      case "manager":
        return "warning";
      case "coach":
        return "info";
      default:
        return "secondary";
    }
  };

  return (
    <Card className="user-card">
      <Card.Body>
        <div className="user-info">
          <div className="user-header">
            <div className="user-avatar">
              <FaUser size={24} />
            </div>
            <div className="user-main-info">
              <h3 className="user-name">{user.userName || "ללא שם"}</h3>
              <Badge
                bg={getRoleBadgeVariant(user.userType)}
                className="role-badge"
              >
                {user.userType || "לא מוגדר סוג משתמש"}
              </Badge>
            </div>
          </div>
          <div className="user-details">
            <div className="detail-item">
              <FaEnvelope className="detail-icon" />
              <span>{user.userEmailAddress || "אין אימייל"}</span>
            </div>
            <div className="detail-item">
              <FaPhone className="detail-icon" />
              <span>{user.userPhoneNumber || "אין טלפון"}</span>
            </div>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default UserCard;
